<template>
    <v-list :two-line="large" style="margin-bottom: 15px"> <!-- List of contents -->
      <v-list-tile v-for="item in items">
        <v-list-tile-avatar> <v-icon>{{item.icon}}</v-icon> </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title>{{item.title}}</v-list-tile-title>
          <v-list-tile-sub-title>{{item.desc}}</v-list-tile-sub-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
</template>

<script>
export default {
  name: 'icon-list',
  props: ['items', 'large'],
}
</script>
